import { Input, Label } from "reactstrap";

const FilterUnitKerja = ({ setSelectedFilterUnitKerja, unitKerja }) => {
  return (
    <>
      <Label className="bg-transparent">DPSJ</Label>
      <Input
        type="select"
        onChange={(e) => setSelectedFilterUnitKerja(e.target.value)}
      >
        <option value={""}>Semua</option>
        {unitKerja.map((uk) => (
          <option key={uk.pk} value={uk.nama_unit_kerja}>
            {uk.nama_unit_kerja}
          </option>
        ))}
      </Input>
    </>
  );
};

export default FilterUnitKerja;
